import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { BloqueConfiguracion, Checklist } from 'src/app/types/type';
declare var $: any;

@Component({
  selector: 'app-checklist-detalle',
  templateUrl: './checklist-detalle.component.html',
  styleUrls: ['./checklist-detalle.component.css']
})
export class ChecklistDetalleComponent implements OnInit {
  idChecklist: number;
  bloqueEdit: any;
  subMenus: { active: boolean; child: boolean; label: string; router: string; class: string; }[];
  preguntaEdit: any;
  tipoRespuestas: object;
  checklist: Checklist;
  bloques: BloqueConfiguracion[];

  constructor(private configService: ConfiguracionService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.idChecklist = parseInt(this.activatedRoute.snapshot.params.id);
  }

  ngOnInit() {
    this.configService.loadInitChecklistDetalle(this.idChecklist)
      .subscribe(([checklist, bloques]) => {
        if (checklist.Result.Exito){
          this.checklist = checklist.Result.Data as Checklist;
          this.loadSubMenu();
        }
        else
          Utilerias.alertClient('', checklist.Result.Error, 1);

        if (bloques.Result.Exito)
          this.bloques = bloques.Result.Data as BloqueConfiguracion[];
        else
          Utilerias.alertClient('', bloques.Result.Error, 1);
      });
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'Listado de checklist',
        router: '../../ChecklistConfiguracion/' + this.checklist.IdTipoRevision,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: true,
        child: false,
        label: 'Checklist detalle',
        router: null,
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }
}
